'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteImage = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * deleteImage
 * 
 * Deletes a particular image from a product.
 * @param {string} feis_id 
 * @param {string} product_id 
 * @param {string} image_id 
 */
var deleteImage = exports.deleteImage = function deleteImage(feis_id, product_id, image_id) {
  return function (dispatch) {

    return dispatch(_defineProperty({
      feis_id: feis_id,
      product_id: product_id,
      image_id: image_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/products/' + product_id + '/images/' + image_id,
        method: 'DELETE'
      },
      types: ['DELETE_IMAGE_START', 'DELETE_IMAGE', 'DELETE_IMAGE_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/deleteImage.js
// module id = 659
// module chunks = 0